import { Paper, Stack, Typography } from "@mui/material";

export const FtiDetailsCard = ({ title, rightContent = null, children }) => (
  <Paper sx={{ overflow: "hidden" }}>
    {title && (
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        gap="16px"
        sx={{ p: "16px 24px", borderBottom: "1px solid #E6E6E6" }}
      >
        <Typography variant="subtitle1" fontWeight={600}>
          {title}
        </Typography>
        {rightContent}
      </Stack>
    )}
    {children}
  </Paper>
);

export const FtiDetailsField = ({ label, children, sx }) => (
  <Stack gap="4px" sx={sx}>
    <Typography variant="body2" fontWeight={600}>
      {label}
    </Typography>
    <Typography variant="body2" color="text.secondary" component="div">
      {children || "--"}
    </Typography>
  </Stack>
);
